export async function postLog(config, authenticationToken, requestData, responseData) {
    try {
        const response = await fetch(`https://${config.apiUrl}/api/operation-logs`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Authorization": authenticationToken
            },
            body: JSON.stringify({
                "request_data": requestData,
                "response_data": responseData
            })
        });
        if (!response.ok) {
            throw new Error(response);
        }
        const logResponse = await response.json();
        console.log(logResponse);
    } catch (error) {
        console.error(error);
    }
}

export async function getLog(config, authenticationToken) {
    try {
        const response = await fetch(`https://${config.apiUrl}/api/operation-logs`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                "Authorization": authenticationToken
            }
        });
        if (!response.ok) {
            throw new Error(response);
        }
        const logResponse = await response.json();
        console.log(logResponse);
    } catch (error) {
        console.error(error);
    }
}